module.exports = __webpack_public_path__ + "static/14-46159aa26da3de3abd99b519a3d1eff0.jpeg";